import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ICrisisStagingAreas } from '../models/crisisStagingAreas';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class CrisisStagingAreasService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getCrisisStagingAreas(buildingId: string): Observable<{has_error: boolean, message: string, data: ICrisisStagingAreas}> {
        const url = environment.apiBaseUrl + endpoints.getCrisisStagingAreas.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: ICrisisStagingAreas}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateCrisisStagingAreas(buildingId: string, data: Partial<ICrisisStagingAreas>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateCrisisStagingAreas.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
